import { render } from "./noticeDetail.vue?vue&type=template&id=60a1d382&scoped=true"
import script from "./noticeDetail.vue?vue&type=script&lang=js"
export * from "./noticeDetail.vue?vue&type=script&lang=js"

import "./noticeDetail.vue?vue&type=style&index=0&id=60a1d382&lang=css"
import "./noticeDetail.vue?vue&type=style&index=1&id=60a1d382&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a1d382"]])

export default __exports__